import axios from 'axios';
import { URL } from './api';

// const notifcontext=useContext(NotifContext)
export const connexionRedux = async (email, password) => {
  return axios.post(URL + '/token', {
    email: email,
    password: password,
  });

  // return resultat
};

export const getParametres = token => {
  return axios.get(`${URL}/api/user-parameters`, {
    headers: {
      Authorization: 'JWT ' + token,
    },
  });
};
export const setParametres = (token, param) => {
  return axios.post(
    `${URL}/api/user-parameters`,
    {
      parametre: param,
    },
    {
      headers: {
        Authorization: 'JWT ' + token,
      },
    }
  );
};

export const getRetention = token =>
  axios.get(`${URL}/api/notification-retention`, {
    headers: { Authorization: 'JWT ' + token },
  });

export const setRetention = (token, days) =>
  axios.put(
    `${URL}/api/notification-retention`,
    { days },
    { headers: { Authorization: 'JWT ' + token } }
  );
